const Firebase = {
  initialize: {
    apiKey: "AIzaSyCOi2QwSFpJJ9eGcuiiwYnGGUULDd8lQqQ",
    authDomain: "code-identity-switcher.firebaseapp.com",
    databaseURL: "https://code-identity-switcher.firebaseio.com",
    projectId: "code-identity-switcher",
    storageBucket: "code-identity-switcher.appspot.com",
    messagingSenderId: "53665435461"
  }
};

export default Firebase;